module.exports = __webpack_public_path__ + "img/fr_fr.14e168aa.png";